import { HeaderToolbar } from "@/components/toolbar/header-toolbar";
import { cn } from "@/utils/cn";
import { IonContent, IonPage } from "@ionic/react";
import { memo } from "react";

interface PlanPageContainerProps {
  id?: string;
  children: React.ReactNode;
  className?: string;
  showBackButton?: boolean;
  bgColor?: string;
}

export const PlanPageContainer = memo(function PlanPageContainer({
  id,
  children,
  className,
  showBackButton = false,
  bgColor,
}: PlanPageContainerProps) {
  return (
    <IonPage id={id} color={bgColor}>
      <HeaderToolbar showBackButton={showBackButton} bgColor={bgColor} />
      <IonContent fullscreen>
        <div
          className={cn(
            "flex flex-col items-start gap-4 justify-start self-center p-4",
            "w-full max-w-[420px] mx-auto h-full",
            className,
          )}
        >
          {children}
        </div>
      </IonContent>
    </IonPage>
  );
});
